const prefix = 'far';
const iconName = 'circle-dot';
const width = 512;
const height = 512;
const aliases = [128280, 'dot-circle'];
const unicode = 'f192';
const svgPathData = 'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
